import { FC } from 'react';
import Head from 'next/head';

type DescriptionMetaTagProps = {
  /**
   * The 'content' of the `<meta name="description" ..>` tag.
   */
  content: string;
};

const DescriptionMetaTag: FC<DescriptionMetaTagProps> = ({ content }) => (
  <Head>
    <meta
      key="meta-description"
      name="description"
      content={content}
    />
  </Head>
);

export default DescriptionMetaTag;
